import { useEffect, useState } from 'react'
export interface TimeLeft {
  hours: number
  minutes: number
  seconds: number
}
const pad = (value: number): string => String(value).padStart(2, '0')
/**
 * Counts down from a fixed number of seconds, floored at zero.
 * Used for the launch-pricing deadline shown in the offer sections.
 */
export function useCountdown(initialSeconds: number): {
  hours: string
  minutes: string
  seconds: string
  isExpired: boolean
} {
  const [remaining, setRemaining] = useState(initialSeconds)
  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((current) => (current <= 1 ? 0 : current - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])
  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
    isExpired: remaining <= 0,
  }
}
